'use strict';

export default class LanguageUtils {
    static isPlural(count) {
        if (count === 1) {
            return 1;
        }

        if (count > 1) {
            return 2;
        }

        // Count = 0
        // French is singular
        if (Vue.config.lang.indexOf('fr') === 0) {
            return 1;
        }

        // Default return plurial
        return 2;
    }
}



// WEBPACK FOOTER //
// ./src/javascript-classes/utils/language.js